module.exports = __webpack_public_path__ + "static/media/logo_cops.d9fa072e.png";